import {useQueryParams, useQueryParamsCallback} from '@aboutyou/router';
import {useCallback} from 'react';
import {SessionGender, useSessionGender} from './sessionGender';
import {convertGenderToTargetGroup} from './useSelectedTargetGroup';

const getTargetGroupIdentifier = (
  queryParams: URLSearchParams,
  sessionGender: SessionGender | undefined,
) => {
  const paramGender = queryParams.get('gender');
  const gender = !paramGender ? sessionGender : paramGender;

  // type assertion ! used here because convertGenderToTargetGroup will default to FEMALE unless we pass {defaultToFemale: false}
  return convertGenderToTargetGroup({gender})!;
};

export const useTargetGroupIdentifier = () => {
  const queryParams = useQueryParams();
  const {gender: sessionGender} = useSessionGender();
  return getTargetGroupIdentifier(queryParams, sessionGender);
};

/**
 * This hooks returns the target group from the URL param without a fallback to the female target group.
 * If the url does not contain the `?gender` param this hook will return `undefined`.
 */
export const useTargetGroupFromUrlParam = () => {
  const queryParams = useQueryParams();
  return convertGenderToTargetGroup({
    gender: queryParams.get('gender') || undefined,
    defaultToFemale: false,
  });
};

export const useTargetGroupIdentifierCallback = () => {
  const queryParamsCallback = useQueryParamsCallback();
  const {gender: sessionGender} = useSessionGender();
  return useCallback(() => {
    return getTargetGroupIdentifier(queryParamsCallback(), sessionGender);
  }, [sessionGender, queryParamsCallback]);
};
